

//queries assigned to new users upon registration
//modify these defaults to change the registration page behaviour
const DEFAULT_TRIAL_QUERIES_COUNT = -1;
const DEFAULT_UNSUBSCRIBED_TRIAL_DAYS = 0;
const DEFAULT_TRIAL_DAYS = 14;
const DEFAULT_PLAN_NICKNAME = "subscription_monthly_plan";

const elapsed = ( date ) => {
    try {
      if (!date)
        return false;
      else {
        return new Date().getTime() > new Date(date).getTime();
      }
    } catch (exc) {
      return false;
    }
  }

const computeTrialDays = ( date ) => {
    try {
        return Math.max(Math.ceil((new Date(date).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)), 0);
    } catch (exc) {
        return 0;
    }
}

export { 
    DEFAULT_TRIAL_QUERIES_COUNT,
    DEFAULT_TRIAL_DAYS,
    DEFAULT_UNSUBSCRIBED_TRIAL_DAYS,
    DEFAULT_PLAN_NICKNAME,
    elapsed,
    computeTrialDays
 }